import {
  MemberMessagesDismissedModel,
  MemberMessagesDismissedResponse,
} from 'types';

import genericNormalizer from './generic';

export const normalizeMessagesDismissed = genericNormalizer<
  MemberMessagesDismissedResponse,
  MemberMessagesDismissedModel
>(({ from }) => ({
  _id: from('_id'),
  count: from('count'),
  lastDismissed: from('lastDismissed'),
  name: from('name'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/messages-dismissed.ts